module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-lazyload-151.990a041e.jpg";